import Marquee from "react-fast-marquee";
import { useLang } from "../../i18n/LanguageContext";

const EditorialMarquee = () => {
  const { t } = useLang();
  return (
    <div data-testid="marquee" className="border-y border-gold/25 bg-cream py-8 md:py-10">
      <Marquee speed={40} gradient={false} autoFill>
        {t.marquee.map((w) => (
          <span key={w} className="flex items-center">
            <span className="font-serif font-light text-ink/85 text-4xl md:text-6xl px-10 md:px-16">
              {w}
            </span>
            <svg width="20" height="14" viewBox="0 0 18 12" fill="none" aria-hidden="true">
              <path
                d="M9 0C9 4 6 6 3 6c3 0 6 2 6 6 0-4 3-6 6-6-3 0-6-2-6-6Z"
                fill="#C5A059"
              />
            </svg>
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default EditorialMarquee;
